import type { CSSProperties } from 'react';

export const TIMESHEET_DAY_KEYS = [
  'sat',
  'sun',
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
] as const;

export type TimesheetDayKey = typeof TIMESHEET_DAY_KEYS[number];

export const TIMESHEET_DAY_LABELS: Record<TimesheetDayKey, string> = {
  sat: 'Sat',
  sun: 'Sun',
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
};

// The timesheet entry grid and the timesheet week hours panel are separate tables
// stacked vertically; their columns only line up while both use fixed layout
// with the same percentage widths and the same minimum table width.
export const TIMESHEET_GRID_MIN_WIDTH = 1180;

export const timesheetGridTableStyle: CSSProperties = { tableLayout: 'fixed' };

/** @registry Column width styles shared by the timesheet entry grid and the timesheet week hours panel so their columns line up. */
export const timesheetGridColumns: Record<
  'payCode' | 'rate' | 'day' | 'total' | 'actions',
  CSSProperties
> = {
  payCode: { width: '8.5%' },
  rate: { width: '6%' },
  day: { width: '8.5%' },
  total: { width: '8.5%' },
  actions: { width: '3%' },
};

// The label column takes what the fixed columns leave; the Rate column only
// exists on service jobs and comes out of the label's share.
export const timesheetGridLabelColumn = (
  isServiceJob: boolean,
): CSSProperties => ({
  width: isServiceJob ? '14.5%' : '20.5%',
});
